module.exports = __webpack_public_path__ + "img/event_type_training.b3b66e05.svg";